module.exports = __webpack_public_path__ + "images/emoji/goberserk.58c8f9c058828c6e423f.png";